import { MathManager } from '@payments-checkout/shared/helpers/index';
import { StatusTrackerProps } from '@stone-payments/jade';
import { useIntl } from 'react-intl';
import { usePageSharedData } from '../../../hooks/usePageSharedData';
import { formatRecurrenceValues } from '../../helpers/formatRecurrenceValues';
import { getFrequencyLabel, getFrequencyTitle } from '../../helpers/frequencyMapper';

export const useRecurrenceValues = () => {
  const { paymentLinkIdData } = usePageSharedData();
  const { formatMessage, locale } = useIntl();
  const isRecurrence = !!paymentLinkIdData.data?.cart_settings?.recurrences;
  const { formattedDateText, price, interval, intervalCount, membershipTax } =
    formatRecurrenceValues({
      recurrence: paymentLinkIdData.data?.cart_settings?.recurrences,
      locale,
    });

  const frequencyLabel = getFrequencyLabel(interval, intervalCount);
  const frequencyTitle = getFrequencyTitle(interval, intervalCount);

  const helpText = formatMessage(
    { id: frequencyLabel.i18nKey },
    { count: frequencyLabel.count }
  ) || frequencyLabel.fallback;

  const description = formatMessage(
    { id: frequencyTitle.i18nKey },
    { count: frequencyTitle.count }
  ) || frequencyTitle.fallback;

  const recurrenceDefaultValues: StatusTrackerProps['items'] = [
    {
      label: `${helpText} · ${MathManager.formatCurrency({
        value: price / 100,
      })}`,
      status: 'next',
      description,
    },
  ];

  if (formattedDateText) {
    let firstValue = 0
    let description = 'recurrenceStatusCard.firstBilling.descriptionWithoutTax'

    if (membershipTax) {
      firstValue = membershipTax
      description = 'recurrenceStatusCard.firstBilling.description'
    }

    recurrenceDefaultValues.unshift({
      label: `${formattedDateText} · ${MathManager.formatCurrency({
        value: price / 100,
      })}`,
      status: 'on-hold',
      description: formatMessage({
        id: 'recurrenceStatusCard.firstBilling.title',
      }),
    })

    recurrenceDefaultValues.unshift({
      label: `${formatMessage({
        id: 'recurrenceStatusCard.firstBilling.today',
      })} · ${MathManager.formatCurrency({ value: firstValue / 100 })}`,
      status: 'completed',
      description: formatMessage({
        id: description,
      }),
    });
  } else {
    let firstValue =  price
    let description = 'recurrenceStatusCard.noFirstBilling.description'

    if (membershipTax) {
      firstValue = membershipTax + price
      description = 'recurrenceStatusCard.firstBilling.descriptionTax'
    }

    recurrenceDefaultValues.unshift({
      label: `${formatMessage({
        id: 'recurrenceStatusCard.firstBilling.today',
      })} · ${MathManager.formatCurrency({ value: firstValue / 100 })}`,
      status: 'completed',
      description: formatMessage({
        id: description,
      }),
    });
  }


  return {
    price,
    isRecurrence,
    statusProps: recurrenceDefaultValues,
  };
};
